<template>
  <div>  
      <b-card>

        <form v-on:submit.prevent="formSubmitted" enctype="multipart/form-data">
          
          <!-- Full Name -->
          <b-row>
            <b-col md="6" xl="6" lg="6" sm="6">
              
                <b-form-group label="First Name" label-for="first-name">
                  <b-form-input
                    id="first-name"
                    v-model="candidateData.firstName"
                    autofocus
                    ref="firstName"
                    trim
                    placeholder="John"
                  />
                <small v-if="error.firstName" class="text-danger">{{ error.firstName }}</small>
                  
                </b-form-group>
              
            </b-col>
            <b-col md="6" xl="6" lg="6" sm="6">
              
                <b-form-group label="Last Name" label-for="last-name">
                  <b-form-input
                    id="last-name"
                    v-model="candidateData.lastName"
                    autofocus
                    trim
                    placeholder="Doe"
                    ref="lastName"
                  />

                <small v-if="error.lastName" class="text-danger">{{ error.lastName }}</small>  
                </b-form-group>
              
            </b-col>
            <b-col md="6" xl="6" lg="6">
              <!-- Email -->
              
                <b-form-group label="Email" label-for="email">
                  <b-form-input
                    id="email"
                    v-model="candidateData.email"
                    trim
                    ref="email"
                    @input="clearError('email')"
                  />

                  <small v-if="error.email" class="text-danger">{{ error.email }}</small>   
                </b-form-group>
              
            </b-col>
            <b-col md="6" xl="6" lg="6">
              <!-- Company -->
              
                <b-form-group label="Contact" label-for="contact">
                  <b-form-input
                    id="contact"
                    v-model="candidateData.contact"
                    ref="contact"
                    trim
                    @input="clearError('contact')"
                  />
                  <small v-if="error.contact" class="text-danger">{{ error.contact }}</small>
                  <small v-if="candidateData.contact && String(candidateData.contact).length !== 10" class="text-danger"> Please Enter 10 Digit Contact Number</small>
                </b-form-group>
             
            </b-col>
            <b-col md="6" xl="6" lg="6">
              <!-- Company -->

              <b-form-group label="Job Title" label-for="job-title">
                <b-form-input id="job-title" v-model="candidateData.jobTitle" placeholder="Current Job Title" ref="job_title" trim />
                <small v-if="error.jobTitle" class="text-danger">{{ error.jobTitle }}</small>
              </b-form-group>
            </b-col>
            
            <b-col md="6" xl="6" lg="6">
              <!-- Candidatename -->
             
                <b-form-group label="Company Name" label-for="companyname">
                  <b-form-input
                    id="company-name"
                    v-model="candidateData.companyName"
                    trim
                    ref="companyName"
                  />
                  <small v-if="error.companyName" class="text-danger">{{ error.companyName }}</small>
                </b-form-group>
              
            </b-col>
            
            
            <b-col md="6" xl="6" lg="6" sm="6">
              
                <b-form-group label="Current CTC" label-for="ctc">
                  <b-form-input
                    id="ctC"
                    v-model="candidateData.ctc"
                    type="number"
                    step=".01"
                    autofocus
                    trim
                    ref="ctc"
                    :placeholder="ctcLabel"
                  />
                  <small v-if="error.ctc" class="text-danger">{{ error.ctc }}</small>
                </b-form-group>
            </b-col>
            <b-col md="6" xl="6" lg="6">
              <!-- Candidatename -->
              <b-form-group label="Expected CTC" label-for="expected-ctc">
                <b-form-input
                  id="expected-ctc"
                  type="number"
                  step=".01"
                  v-model="candidateData.expectedCTC"
                  autofocus
                  trim
                  ref="expectedCTC"
                  :placeholder="ctcLabel"
                  @input="clearError('expectedCTC')"
                />
                <small v-if="error.expectedCTC" class="text-danger">{{ error.expectedCTC }}</small>
              </b-form-group>
            </b-col>
            
            <b-col md="6" xl="6" lg="6">
              <!-- Email -->
                <b-form-group label="Experience" label-for="experience">
                  <b-form-input
                    id="experience"
                    v-model="candidateData.exp"
                    type="number"
                    step=".01"
                    trim
                    ref="exp"
                  />           
                  <small v-if="error.exp" class="text-danger">{{ error.exp }}</small>       
                </b-form-group>
              
            </b-col>
            <b-col md="6" xl="6" lg="6">
              <!-- Email -->
                <b-form-group label="Relevant Experience" label-for="rel-experience">
                  <b-form-input
                    id="rel-experience"
                    v-model="candidateData.relevant_exp"
                    type="number"
                    step=".01"
                    trim
                    ref="relevant_exp"
                  />           
                  <small v-if="error.relevant_exp" class="text-danger">{{ error.relevant_exp }}</small>       
                </b-form-group>
              
            </b-col>
            <b-col md="6" xl="6" lg="6">
              <!-- Email -->
              
                <b-form-group label="Notice Period" label-for="notice-period">
                  <!--<b-form-input
                    id="notice-period"
                    v-model="candidateData.noticePeriod"
                    type="number"
                    step=".01"
                    trim
                    ref="noticePeriod"
                    placeholder="In Days"
                  />-->
                  <v-select
                    id="notice-period"
                    label="value"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    v-model="candidateData.noticePeriod"
                    ref="noticePeriod"
                    :options="noticePeriodOptions"
                    :reduce="(option) => option.text"
                />
                  <small v-if="error.noticePeriod" class="text-danger">{{ error.noticePeriod }}</small>
                </b-form-group>
            </b-col>
            <b-col md="6" xl="6" lg="6">
              
                <b-form-group label="City" label-for="city">
                  <v-select
                    v-model="candidateData.selectedCity"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="title"
                    :options="cities"
                    ref="city"
                    :reduce="(option) => option.title"
                  />
                </b-form-group>
                <small v-if="error.selectedCity" class="text-danger">{{ error.selectedCity }}</small>
            </b-col>
            <b-col md="6" xl="6" lg="6">
              
                <b-form-group label="Preferred Location" label-for="pre-city">
                  <v-select
                    v-model="candidateData.preferredCities"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="title"
                    :options="cities"
                    :close-on-select="false"
                    multiple
                    ref="preCity"
                  />
                </b-form-group>
                <small v-if="error.preferredCities" class="text-danger">{{ error.preferredCities }}</small>
            </b-col>
            <b-col md="6" xl="6" lg="6">
              <!-- Country -->
                <b-form-group
                  label="Skills"
                  label-for="skills"
                >
                  <!--<b-form-input
                    id="skills-selected"
                    v-model="candidateData.skillsSelected"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    trim
                    ref="skills"
                  />-->
                  <v-select
                    v-model="candidateData.skillsSelected"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="title"
                    :options="skillsOptions"
                    :reduce="(option) => option.title"
                    
                    ref="skills"
                  />
                  <small v-if="error.skillsSelected" class="text-danger">{{ error.skillsSelected }}</small>
                </b-form-group>
            </b-col>

            <b-col md="6" xl="6" lg="6">
              <!-- Candidate Role -->

              <b-form-group label="Qualification" label-for="qualification">
                <v-select
                  id="qual"
                  v-model="candidateData.qualification"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="qualifications"
                  label="title"
                  ref="qualification"
                  :reduce="(option) => option.title"
                />
              </b-form-group>
              <small v-if="error.qualification" class="text-danger">{{ error.qualification }}</small>
            </b-col>
            <b-col md="6" xl="6" lg="6">
              <!-- Plan -->

              <b-form-group label="Source" label-for="source">
                <v-select
                  v-model="candidateData.source"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="sources"
                  input-id="source"
                  label="title"
                  ref="source"
                  :reduce="(option) => option.title"

                />
              </b-form-group>
              <small v-if="error.source" class="text-danger">{{ error.source }}</small>
            </b-col>
            <b-col md="6" xl="6" lg="6">
              <!-- Candidate Role -->
                <b-form-group
                  label="DOB"
                  label-for="dob"
                >
                  <!--<b-form-datepicker 
                    id="dob" 
                    v-model="candidateData.dob" 
                    class="mb-1"
                    :show-decade-nav=true
                    locale="en-IN" />-->
                  <flat-pickr
                    class="form-control"
                    id="dob" 
                    v-model="candidateData.dob" 
                    
                    placeholder="YYYY-MM-DD"
                  />
                  
                  <small v-if="error.dob" class="text-danger">{{ error.dob }}</small>
                  <small v-if="candidateData.dob && positionType === 'Contractual' && calculateAge(candidateData.dob) < 18" class="text-danger"> Under Age Alert!!! Please do not add these candidate</small>
                </b-form-group>
            </b-col>
            <b-col md="6" xl="6" lg="6">
              <!-- Plan -->

              <b-form-group label="Gender" label-for="gender">
                <v-select
                  v-model="candidateData.genderSelected"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="genderOptions"
                  input-id="gender"
                  label="title"
                  ref="gender"
                  :reduce="(option) => option.title"
                />
              </b-form-group>
              <small v-if="error.gender" class="text-danger">{{ error.gender }}</small>
            </b-col>

            <!-- Add KPMG RPO fields here -->
            <template v-if="client === 'KPMG RPO' && (jobId === 3194 || jobId === 3425 || jobId === 3385)">
              <!-- <b-col md="6" xl="6" lg="6">
                <b-form-group label="Business" label-for="business">
                  <v-select
                    id="business"
                    v-model="extraDetails.business"
                    :options="businessList"
                    label="title"
                    placeholder="Select Business"
                    :reduce="(option) => option.title"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  />
                </b-form-group>
              </b-col> -->

              <!-- <b-col md="6" xl="6" lg="6">
                <b-form-group label="POCs" label-for="pocs">
                    <v-select
                      id="pocs"
                      v-model="extraDetails.pocs"
                      :options="pocList"
                      label="title"
                      placeholder="Select POCs"
                      :reduce="(option) => option.title"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    />
                </b-form-group>
              </b-col> -->

              <b-col md="6" xl="6" lg="6">
                <b-form-group label="Req ID" label-for="reqId">
                  <b-form-input
                    id="reqId"
                    v-model="extraDetails.reqId"
                    placeholder="Enter Req ID"
                  />
                </b-form-group>
              </b-col>

              <b-col md="6" xl="6" lg="6">
                <b-form-group label="Candidate ID" label-for="candidateId">
                  <b-form-input
                    id="candidateId"
                    v-model="extraDetails.candidateId"
                    placeholder="Enter Candidate ID"
                  />
                </b-form-group>
              </b-col>

              <b-col md="6" xl="6" lg="6">
                <b-form-group label="Level" label-for="level">
                  <v-select
                    id="level"
                    v-model="extraDetails.level"
                    :options="levelList"
                    label="title"
                    :reduce="(option) => option.title"
                    placeholder="Select Level"
                  />
                </b-form-group>
              </b-col>
              <b-col md="6" xl="6" lg="6">
                <b-form-group label="Which all juridictions have you done KYC for?" label-for="jurisdictions">
                  <b-form-input
                    id="jurisdictions"
                    v-model="extraDetails.jurisdictions"
                    placeholder="Enter Jurisdictions"
                  />
                </b-form-group>
              </b-col>
              <b-col md="6" xl="6" lg="6">
                <b-form-group label="Communication Score" label-for="communicationScore">
                  <b-form-input
                    id="communicationScore"
                    v-model="extraDetails.communicationScore"
                    placeholder="Enter Communication Score"
                    type="number"
                  />
                </b-form-group>
              </b-col>
            </template>

            <b-col md="6" xl="6" lg="6">
              <!-- Plan -->
              <b-form-group label="Upload Resume" label-for="resume">
                <b-form-file
                  placeholder="Choose a file or drop it here..."
                  drop-placeholder="Drop file here..."
                  id="cv-file"
                  name="cv-file"
                  accept="application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/pdf, text/plain, application/rtf, text/markdown"
                  @change="openFile"
                  v-model="candidateData.file"
                  type="file"
                  ref="file"
                />
              </b-form-group>
              <small v-if="error.file" class="text-danger">{{ error.file }}</small>
              <small v-if="file && file.size > 1690000" class="text-danger"> File Size Should be less than 1.5 mb </small>
              <small v-if="existingResumeName && !candidateData.file" class="text-muted d-block">Current resume: {{ existingResumeName }}</small>
            </b-col>
            <b-col md="6" xl="6" lg="6">
              <!-- Plan -->
              <b-form-group label="Remarks" label-for="remarks">
                <b-form-textarea
                  id="textarea-default"
                  placeholder="Add Remark"
                  rows="3"
                  v-model="candidateData.remarks"
                />
              </b-form-group>
            </b-col>
            <b-col md="6" xl="6" lg="6" v-if="!isNotAnsweredCandidate">
              <!-- Plan -->
              <b-form-group label-for="remarks">
                <span class="text-primary">Do you wish to share Profile Shared Email with Candidate?</span>
                <div class="demo-inline-spacing">
                  <b-form-radio
                    v-model="emailSendSelected"
                    name="yes-radio-btn"
                    value="YES"
                    class="custom-control-primary"
                  >
                    YES
                  </b-form-radio>
                  <b-form-radio
                    v-model="emailSendSelected"
                    name="no-radio-btn"
                    value="NO"
                    class="custom-control-danger"
                  >
                    NO
                  </b-form-radio>
                </div>
              </b-form-group>
            </b-col>
          </b-row>
          <!-- Form Actions -->
          <div class="d-flex mt-2">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="mr-2"
              :disabled="candidateData.dob && positionType === 'Contractual' && calculateAge(candidateData.dob) < 18 ? true: buttonClicked" 
              type="submit"
              value="submit"
              id="submit"
              
            >
              {{ submitStatus }}
            </b-button>
            <b-button @click="router.go(-1)">
              Cancel
            </b-button>
          </div>
        </form>
      </b-card>
      <b-modal
      hide-header-close
      ref="can-remarks-check"
      title="Candidate Hygiene Issue!!!"
      cancel-variant="outline-secondary"
      no-close-on-backdrop
      ok-title="ACCEPT"
      cancel-title="Cancel"
      centered
      @ok="confirmRemarks"
      @cancel="enableButton"
    >
      <div class="d-block text-center">
        
        <b-list-group flush>
          <b-list-group-item v-for="(r, index) in remarks" :key="index"><span class="text-danger">{{ r }}</span></b-list-group-item>
        </b-list-group>
      
        
        <h5 class="mt-1">Make sure this candidate has been added as an exception after discussing with client!!!</h5>
        <h5>Please confirm do you agree to proceed with this candidate?</h5>
      </div>
      
    </b-modal>
    <!--</template>
  </b-sidebar>-->
  </div>
</template>

<script>
import {

  BForm,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BCard,
  BRow,
  BCol,
  BFormDatepicker,
  BFormFile,
  BFormTextarea,
  BButton, BSidebar, VBToggle, BListGroup, BListGroupItem, BFormRadio
} from "bootstrap-vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { ref } from "vue";
import { required, alphaNum, email } from "@validations";
//import formValidation from "@core/comp-functions/forms/form-validation";
import Ripple from 'vue-ripple-directive'
import vSelect from "vue-select";
import countries from "@/@fake-db/data/other/countries";
//import store from "@/store";
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import CandidateService from '@/services/candidate-service'
import JobService from '@/services/job-service'
import jobTimelineService from '@/services/job-timeline'
import flatPickr from 'vue-flatpickr-component'
import emailTemplates from "@/services/email-templates";
import mailService from "@/services/mail-service"
import UserService from "@/services/user-service"
import locationService from "@/services/location-service";
import adminConfigService from "@/services/admin-config-service";

export default {
  components: {
    BSidebar, BButton, VBToggle,
    BForm,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BCard,
    vSelect,
    BRow,
    BCol,
    BFormDatepicker,
    BFormFile,
    BFormTextarea,
    // Form Validation
    ValidationProvider,
    ValidationObserver,
    flatPickr, BListGroup, BListGroupItem, BFormRadio
  },
  directives: {
    'b-toggle': VBToggle,
    Ripple,
  },
  props:   {
      label: { type: String },
      value: { type: [Object, File] },
      placeholder: { type: String, default: "Choose a file..." },
  },  
  /*props: {
    jobId:  Number
  },*/
  data() {
    return {
      required,
      alphaNum,
      email,
      countries,
      selectedCity: { title: "Pune" },
      preferredCities: '',
      formData: {},
      //selectedState: { title: "Maharashtra" },
      cities: [{"title":"Mumbai"},{"title":"Delhi"},{"title":"Bangalore"},{"title":"Hyderabad"},{"title":"Pune"},{"title":"Ahmedabad"},{"title":"Chennai"},{"title":"Kolkata"},{"title":"Surat"},{"title":"Jaipur"},{"title":"Lucknow"},{"title":"Kanpur"},{"title":"Nagpur"},{"title":"Indore"},{"title":"Thane"},{"title":"Bhopal"},{"title":"Visakhapatnam"},{"title":"Pimpri and Chinchwad"},{"title":"Patna"},{"title":"Vadodara"},{"title":"Ghaziabad"},{"title":"Ludhiana"},{"title":"Agra"},{"title":"Nashik"},{"title":"Faridabad"},{"title":"Meerut"},{"title":"Rajkot"},{"title":"Kalyan and Dombivali"},{"title":"Vasai Virar"},{"title":"Varanasi"},{"title":"Srinagar"},{"title":"Aurangabad"},{"title":"Dhanbad"},{"title":"Amritsar"},{"title":"Navi Mumbai"},{"title":"Allahabad"},{"title":"Haora"},{"title":"Ranchi"},{"title":"Gwalior"},{"title":"Jabalpur"},{"title":"Coimbatore"},{"title":"Vijayawada"},{"title":"Jodhpur"},{"title":"Madurai"},{"title":"Raipur"},{"title":"Kota"},{"title":"Chandigarh"},{"title":"Guwahati"},{"title":"Solapur"},{"title":"Hubli and Dharwad"},{"title":"Bareilly"},{"title":"Mysore"},{"title":"Moradabad"},{"title":"Gurgaon"},{"title":"Aligarh"},{"title":"Jalandhar"},{"title":"Tiruchirappalli"},{"title":"Bhubaneswar"},{"title":"Salem"},{"title":"Mira and Bhayander"},{"title":"Thiruvananthapuram"},{"title":"Bhiwandi"},{"title":"Saharanpur"},{"title":"Gorakhpur"},{"title":"Guntur"},{"title":"Amravati"},{"title":"Bikaner"},{"title":"Noida"},{"title":"Jamshedpur"},{"title":"Bhilai Nagar"},{"title":"Warangal"},{"title":"Cuttack"},{"title":"Firozabad"},{"title":"Kochi"},{"title":"Bhavnagar"},{"title":"Dehradun"},{"title":"Durgapur"},{"title":"Asansol"},{"title":"Nanded Waghala"},{"title":"Kolapur"},{"title":"Ajmer"},{"title":"Gulbarga"},{"title":"Loni"},{"title":"Ujjain"},{"title":"Siliguri"},{"title":"Ulhasnagar"},{"title":"Jhansi"},{"title":"Sangli Miraj Kupwad"},{"title":"Jammu"},{"title":"Nellore"},{"title":"Mangalore"},{"title":"Belgaum"},{"title":"Jamnagar"},{"title":"Tirunelveli"},{"title":"Malegaon"},{"title":"Gaya"},{"title":"Ambattur"},{"title":"Jalgaon"},{"title":"Udaipur"},{"title":"Maheshtala"},{"title":"Tiruppur"},{"title":"Davanagere"},{"title":"Kozhikode"},{"title":"Kurnool"},{"title":"Akola"},{"title":"Rajpur Sonarpur"},{"title":"Bokaro Steel"},{"title":"Bellary"},{"title":"Patiala"},{"title":"South Dum Dum"},{"title":"Rajarhat Gopalpur"},{"title":"Bhagalpur"},{"title":"Agartala"},{"title":"Muzaffarnagar"},{"title":"Bhatpara"},{"title":"Latur"},{"title":"Panihati"},{"title":"Dhule"},{"title":"Rohtak"},{"title":"Korba"},{"title":"Bhilwara"},{"title":"Brahmapur Town"},{"title":"Muzaffarpur"},{"title":"Ahmadnagar"},{"title":"Mathura"},{"title":"Kollam"},{"title":"Avadi"},{"title":"Kadapa"},{"title":"Rajahmundry"},{"title":"Bilaspur"},{"title":"Kamarhati"},{"title":"Shahjahanpur"},{"title":"Bijapur"},{"title":"Rampur"},{"title":"Shimoga"},{"title":"Chandrapur"},{"title":"Junagadh"},{"title":"Thrissur"},{"title":"Alwar"},{"title":"Barddhaman"},{"title":"Kulti"},{"title":"Kakinada"},{"title":"Nizamabad"},{"title":"Parbhani"},{"title":"Tumkur"},{"title":"Hisar"},{"title":"Ozhukarai"},{"title":"Biharsharif"},{"title":"Darbhanga"},{"title":"Panipat"},{"title":"Aizawl"},{"title":"Bally"},{"title":"Dewas"},{"title":"Tirupati"},{"title":"Ichalkaranji"},{"title":"Karnal"},{"title":"Bathinda"},{"title":"Jalna"},{"title":"Kirari Suleman Nagar"},{"title":"Purnia"},{"title":"Satna"},{"title":"Maunath Bhanjan"},{"title":"Barasat"},{"title":"Sonipat"},{"title":"Farrukhabad and Fatehgarh"},{"title":"Sagar"},{"title":"Raurkela"},{"title":"Durg"},{"title":"Imphal"},{"title":"Ratlam"},{"title":"Hapur"},{"title":"Arrah"},{"title":"Karimnagar"},{"title":"Anantapur"},{"title":"NDMC"},{"title":"Etawah"},{"title":"Ambernath"},{"title":"Bharatpur"},{"title":"Begusarai"},{"title":"Tiruvottiyur"},{"title":"North Dum Dum"},{"title":"Gandhidham"},{"title":"Baranagar"},{"title":"Puducherry"},{"title":"Thoothukkudi"},{"title":"Sikar"},{"title":"Rewa"},{"title":"Mirzapur and Vindhyachal"},{"title":"Raichur"},{"title":"Pali"},{"title":"Ramagundam"},{"title":"Hardwar"},{"title":"Vizianagaram"},{"title":"Katihar"},{"title":"Nagercoil"},{"title":"Ganganagar"},{"title":"Karawal Nagar"},{"title":"Mango"},{"title":"Thanjavur"},{"title":"Bulandshahr"},{"title":"Uluberia"},{"title":"Murwara"},{"title":"Sambhal"},{"title":"Singrauli"},{"title":"Nadiad"},{"title":"Secunderabad"},{"title":"Naihati"},{"title":"Yamunanagar"},{"title":"Bidhan Nagar"},{"title":"Pallavaram"},{"title":"Bidar"},{"title":"Munger"},{"title":"Panchkula"},{"title":"Burhanpur"},{"title":"Raurkela Industrial Township"},{"title":"Kharagpur"},{"title":"Dindigul"},{"title":"Hospet"},{"title":"Gandhinagar"},{"title":"Nangloi Jat"},{"title":"English Bazar"},{"title":"Ongole"},{"title":"Eluru"},{"title":"Deoghar"},{"title":"Chapra"},{"title":"Haldia"},{"title":"Khandwa"},{"title":"Puri Town"},{"title":"Nandyal"},{"title":"Morena"},{"title":"Amroha"},{"title":"Anand"},{"title":"Bhind"},{"title":"Bhalswa Jahangir Pur"},{"title":"Madhyamgram"},{"title":"Bhiwani"},{"title":"Navi Mumbai Panvel Raigad"},{"title":"Baharampur"},{"title":"Ambala"},{"title":"Morvi"},{"title":"Fatehpur"},{"title":"Rae Bareli"},{"title":"Khora"},{"title":"Bhusawal"},{"title":"Orai"},{"title":"Bahraich"},{"title":"Vellore"},{"title":"Mahesana"},{"title":"Khammam"},{"title":"Sambalpur"},{"title":"Raiganj"},{"title":"Sirsa"},{"title":"Dinapur Nizamat"},{"title":"Serampore"},{"title":"Sultan Pur Majra"},{"title":"Guna"},{"title":"Jaunpur"},{"title":"Panvel"},{"title":"Shivpuri"},{"title":"Surendranagar Dudhrej"},{"title":"Unnao"},{"title":"Hugli and Chinsurah"},{"title":"Sitapur"},{"title":"Hastsal"},{"title":"Tambaram"},{"title":"Adityapur"},{"title":"Badalapur"},{"title":"Alappuzha"},{"title":"Cuddalore"},{"title":"Silchar"},{"title":"Gadag and Betigeri"},{"title":"Bahadurgarh"},{"title":"Machilipatnam"},{"title":"Shimla"},{"title":"Medinipur"},{"title":"Deoli"},{"title":"Bharuch"},{"title":"Hoshiarpur"},{"title":"Jind"},{"title":"Chandannagar"},{"title":"Adoni"},{"title":"Tonk"},{"title":"Faizabad"},{"title":"Tenali"},{"title":"Alandur"},{"title":"Kancheepuram"},{"title":"Vapi"},{"title":"Rajnandgaon"},{"title":"Proddatur"},{"title":"Navsari"},{"title":"Budaun"},{"title":"Uttarpara Kotrung"},{"title":"Mahbubnagar"},{"title":"Erode"},{"title":"Batala"},
      {"title":"Saharsa"},{"title":"Haldwani and Kathgodam"},{"title":"Vidisha"},{"title":"Thanesar"},{"title":"Kishangarh"},{"title":"Dallo Pura"},{"title":"Veraval"},{"title":"Banda"},{"title":"Chittoor"},{"title":"Krishnanagar"},{"title":"Barrackpur"},{"title":"Lakhimpur"},{"title":"Santipur"},{"title":"Porbandar"},{"title":"Hindupur"},{"title":"Balurghat"},{"title":"Bhadravati"},{"title":"Hanumangarh"},{"title":"Moga"},{"title":"Pathankot"},{"title":"Hajipur"},{"title":"Sasaram"},{"title":"Habra"},{"title":"Bid"},{"title":"Mohali"},{"title":"Burari"},{"title":"Beawar"},{"title":"Abohar"},{"title":"Tiruvannamalai"},{"title":"Jamuria"},{"title":"Kaithal"},{"title":"Godhra"},{"title":"Bhuj"},{"title":"Robertson Pet"},{"title":"Shillong"},{"title":"Rewari"},{"title":"Hazaribag"},{"title":"Bhimavaram"},{"title":"Mandsaur"},{"title":"Chas"},{"title":"Rudrapur"},{"title":"Chitradurga"},{"title":"Kumbakonam"},{"title":"Dibrugarh"},{"title":"Kolar"},{"title":"Chhindwara"},{"title":"Bankura"},{"title":"Mandya"},{"title":"Dehri"},{"title":"Raigarh"},{"title":"Madanapalle"},{"title":"Nalgonda"},{"title":"Hathras"},{"title":"Malerkotla"},{"title":"Siwan"},{"title":"Chhattarpur"},{"title":"Hassan"},{"title":"Lalitpur"},{"title":"Gondiya"},{"title":"North Barrackpur"},{"title":"Bettiah"},{"title":"Palakkad"},{"title":"Rajapalayam"},{"title":"Botad"},{"title":"Modinagar"},{"title":"Deoria"},{"title":"Raniganj"},{"title":"Palwal"},{"title":"Khanna"},{"title":"Neemuch"},{"title":"Pilibhit"},{"title":"Mustafabad"},{"title":"Hardoi"},{"title":"Guntakal"},{"title":"Pithampur"},{"title":"Motihari"},{"title":"Dhaulpur"},{"title":"Srikakulam"},{"title":"Nabadwip"},{"title":"Patan"},{"title":"Jagdalpur"},{"title":"Udupi"},{"title":"Basirhat"},{"title":"Damoh"},{"title":"Halisahar"},{"title":"Jagadhri"},{"title":"Rishra"},{"title":"Kurichi"},{"title":"Dimapur"},{"title":"Palanpur"},{"title":"Dharmavaram"},{"title":"Gokal Pur"},{"title":"Kashipur"},{"title":"Ashokenagar Kalyangarh"},{"title":"Baidyabati"},{"title":"Sawai Madhopur"},{"title":"Puruliya"},{"title":"Mandoli"},{"title":"Mainpuri"},{"title":"Kanchrapara"},{"title":"Satara"},{"title":"Churu"},{"title":"Madavaram"},{"title":"Gangapur"},{"title":"Dabgram"},{"title":"Darjiling"},{"title":"Barshi"},{"title":"Etah"},{"title":"Jhunjhunun"},{"title":"Chikmagalur"},{"title":"Jetpur Navagadh"},{"title":"Roorkee"},{"title":"Gudivada"},{"title":"Baleshwar"},{"title":"Baran"},{"title":"Hoshangabad"},{"title":"Nagaon"},{"title":"Pudukkottai"},{"title":"Adilabad"},{"title":"Hosur"},{"title":"Muktsar"},{"title":"Yavatmal"},{"title":"Titagarh"},{"title":"Barnala"},{"title":"Chittaurgarh"},{"title":"Narasaraopet"},{"title":"Dum Dum"},{"title":"Basti"},{"title":"Valsad"},{"title":"Ambur"},{"title":"Giridih"},{"title":"Chandausi"},{"title":"Gonda"},{"title":"Bally Town"},{"title":"Kalol"},{"title":"Bagaha"},{"title":"Ambikapur"},{"title":"Achalpur"},{"title":"Gondal"},{"title":"Bagalkot"},{"title":"Osmanabad"},{"title":"Akbarpur"},{"title":"Champdani"},{"title":"Deesa"},{"title":"Khurja"},{"title":"Nandurbar"},{"title":"Azamgarh"},{"title":"Ghazipur"},{"title":"Delhi Cantonment"},{"title":"Firozpur"},{"title":"Baripada"},{"title":"Mughalsarai"},{"title":"Anantnag"},{"title":"Sehore"},{"title":"Bongaon"},{"title":"Kanpur Cantonment"},{"title":"Khardaha"},{"title":"Tadpatri"},{"title":"Port Blair"},{"title":"Sultanpur"},{"title":"Bhadrak"},{"title":"Shikohabad"},{"title":"Jalpaiguri"},{"title":"Shamli"},{"title":"Karaikkudi"},{"title":"Khargone"},{"title":"Wardha"},{"title":"Ranibennur"},{"title":"Kishanganj"},{"title":"Neyveli"},{"title":"Amreli"},{"title":"Suryapet"},{"title":"Gangawati"},{"title":"Hindaun"},{"title":"Jamalpur"},{"title":"Bhiwadi"},{"title":"Ballia"},{"title":"Bansberia"},{"title":"Tadepalligudem"},{"title":"Miryalaguda"},{"title":"Baraut"},{"title":"Udgir"},{"title":"Betul"},{"title":"Bundi"},{"title":"Jehanabad"},{"title":"Ambala Sadar"},{"title":"Nagapattinam"},{"title":"Nagaur"},{"title":"Buxar"},{"title":"Seoni"},{"title":"Greater Noida"},{"title":"Hinganghat"},{"title":"Sujangarh"},{"title":"Bhadreswar"},{"title":"Chilakaluripet"},{"title":"Kasganj"},{"title":"Kalyani"},{"title":"Gangtok"},{"title":"Datia"},{"title":"Nagda"},{"title":"Banswara"},{"title":"Kapurthala"}, {"title": "Remote"}, {"title": "PAN INDIA"}, {"title": "Ratnagiri"}, {"title": "Goa"}, {"title": "Panaji"}],
      //response: 'hi there',
      id: '',
      jId: this.jobId,
      // genderOptions: [
      //   { title: "Male" },
      //   { title: "Female" },
      //   { title: "Transgender" },
      //   { title: "Non-binary/non-conforming" },
      //   { title: "Prefer not to respond" },
      // ],
      genderOptions: [
        { title: "Male" },
        { title: "Female" },
        { title: "LGBQ" },
        { title: "Transgender" },
      ],
      qualifications: [],
      specialization: [{ title: "Agriculture" }, 
        { title: "Automobile" }, 
        { title: "Aviation" }, 
        { title: "Bio-Chemistry/Bio-Technology" }, 
        { title: "Biomedical" }, 
        { title: "Ceramics" }, 
        { title: "Chemical" }, 
        { title: "Civil" }, 
        { title: "Computers" }, 
        { title: "Electrical" }, 
        { title: "Electronics/Telecommunication" }, 
        { title: "Energy" }, 
        { title: "Environmental" }, 
        { title: "Instrumentation" }, 
        { title: "Marine" }, 
        { title: "Mechanical" }, 
        { title: "Metallurgy" }, 
        { title: "Mineral" }, 
        { title: "Mining" }, 
        { title: "Nuclear" }, 
        { title: "Paint/Oil" }, 
        { title: "Petroleum" }, 
        { title: "Plastics" }, 
        { title: "Production/Industrial" }, 
        { title: "Textile" }, 
        { title: "OtherSpecialization" }],
      sources: [
        { title: "Naukri" },
        { title: "NaukriMassMailer" },
        { title: "FounditMassMailer" },
        { title: "Monster" },
        { title: "LinkedIn" },
        { title: "Indeed" },
        { title: "Shine" },
        { title: "TimesJobs" },
        { title: "IIMJobs" },
        { title: "Glassdoor" },
        { title: "FreshersWorld" },
        { title: "Other" },
        { title: "Train N Hire" },
        { title: "Internal" },
        { title: "Referenced" },
        { title: "MassMailer" },
      ],
      noticePeriodOptions: [
        { value: 'Immediate', text: 0 },
        { value: 15, text: 15 },
        { value: 30, text: 30 },
        { value: 45, text: 45 },
        { value: 60, text: 60 },
        { value: 90, text: 90 },
      ],
      candidateData: {
        firstName: "",
        lastName: "",
        email: "",
        companyName: "",
        contact: "",
        jobTitle: "",
        selectedCity: "",
        ctc: null,
        expectedCTC: null,
        exp: null,
        noticePeriod: null,
        skillsSelected: "",
        source: "",
        qualification: "",
        dob: null,
        genderSelected: "",
        file: null,
        remarks: "",
        relevant_exp: null,
        cv_path: null
    },
    originalCandidate: {},
    //isAddNewCandidateSidebarActive: false,
    error: {
      firstName: '',
      lastName: '',
      email: '',
      contact: '',
      exp: '',
      relevant_exp: '',
      selectedCity: '',
      skillsSelected: '',
      qualification: '',
      source: '',
      genderSelected: '',
      companyName: '',
      jobTitle: '',
      ctc: '',
      expectedCTC: '',
      noticePeriod: '',
      dob: '',
      preferredCities: '',
      file: '',
      gender: '',
    },
    skillsOptions: [],
    jobId: '',
    file: null,
    prevStatus: '',
    forMail: {},
    position_name: '',
    locations: '',
    client: '',
    rec_name: '',
    attachments: '',
    interested: '',
    src: '',
    allUsers: [],
    jobData: {},
    canHtmlRemarks: '',
    confirmRemark: false,
    remarks: [],
    submitStatus: 'Update',
    buttonClicked: false,
    positionType: null,
    vertical: null,
    category: null,
    payroll: null,
    blueCollar: false,
    ctcLabel: 'CTC in Lacs',
    sendEmail: true,
    emailSendSelected: 'YES',
    extraDetails: {
      business: '',
      pocs: '',
      reqId: '',
      candidateId: '',
      level: '',
      jurisdictions: '',
      communicationScore: ''
    },
    businessList: [],
    pocList: [],
    levelList: []
    };
        
  },
  
  created() {
    this.isLoggedIn()
    if (this.$route.query) {
      this.position_name = this.$route.query.position_name
      this.locations = this.$route.query.locations
      this.client = this.$route.query.client
      this.rec_name = this.$route.query.rec_name
      this.attachments = this.$route.query.attachments
      this.interested = this.$route.query.interested
      this.src = this.$route.query.src
      this.positionType = this.$route.query.position_type
      this.vertical = this.$route.query.vertical
      this.category = this.$route.query.category
      this.payroll = this.$route.query.payroll
      if (this.$route.query.candidateStatus) {
        this.prevStatus = this.$route.query.candidateStatus
      }

    }
    if(this.positionType === 'Contractual' && this.category === 'Blue Collar' && this.payroll === 'Sattva Payroll' && this.vertical === 'Infra Industry') {
      this.blueCollar = true
      this.ctcLabel = 'Monthly Salary'
    }
    
    JobService.getJobPositionList().then(res => {
      console.log(res.data)
      this.skillsOptions = res.data
    })

    locationService.getAll().then(res => {
      console.log(res.data)
      this.cities = res.data
    })
    this.id = this.$route.params.id
    this.jobId = parseInt(this.$route.params.jobId)
    console.log(this.id, this.jobId)
    this.jobId = this.jobId === 'null' ? '' : this.jobId
    console.log(this.id, this.jobId)
    UserService.getAllUsersDdActiveInactive().then(res => {
      this.allUsers = res.data
      console.log('allUsers',this.allUsers)
    })
    CandidateService.getAllCandidates(this.id).then( res => {
      console.log(res)
      if(res.status === "OK") {
        let prefCities = [];
        const can_data = res.data[0]
        console.log(can_data)
        if(can_data.pref_location) {
          const prefCityArray = can_data.pref_location.split(",");
          for (var i = 0; i < prefCityArray.length; i++) {
            prefCities.push({"title" : prefCityArray[i]})
          }
        } 
        console.log('job locations src', this.src, this.$route.query.src) 
        if(this.jobId && this.src !== 'BooleanSearch') {
        const job = can_data.jobs.filter(item => item.id === this.jobId)[0]
        console.log(job)
        this.jobData = {
          id: this.jobId,
          job_id: job.job_id,
          position_name : job.position_name,
          client : JSON.parse(job.client)[0].title,
          locations : job.locations,
          account_mgr: JSON.parse(job.account_mgr)[0].title,
          attachments: this.$route.query.attachments,
          sourcer: job.sourcer,
          account_mgr_id: JSON.parse(job.account_mgr)[0].emp_id,
          min_exp: parseFloat(job.min_exp),
          max_exp: parseFloat(job.max_exp),
          min_ctc: parseFloat(job.min_ctc),
          max_ctc: parseFloat(job.max_ctc),
          notice_period: parseInt(job.notice_period),
          category: job.category,
          vertical: job.vertical,
        }
        if (!this.category && job.category) {
          this.category = job.category
        }
        if (!this.vertical && job.vertical) {
          this.vertical = job.vertical
        }
        if (this.positionType === 'Contractual' && this.category === 'Blue Collar' && this.payroll === 'Sattva Payroll' && this.vertical === 'Infra Industry') {
          this.blueCollar = true
          this.ctcLabel = 'Monthly Salary'
        }
        console.log('job locations list', this.jobData.locations)
        
      } else if(this.jobId && this.src === 'BooleanSearch'){
        this.jobData = {
          id: this.jobId,
          job_id: this.$route.query.job_id,
          position_name : this.$route.query.position_name,
          client : this.$route.query.client,
          locations : this.$route.query.locations,
          account_mgr: this.$route.query.account_mgr,
          attachments: this.$route.query.attachments,
          sourcer: null,
          account_mgr_id: this.$route.query.account_mgr_id,
          min_exp: parseFloat(this.$route.query.min_exp),
          max_exp: parseFloat(this.$route.query.max_exp),
          min_ctc: parseFloat(this.$route.query.min_ctc),
          max_ctc: parseFloat(this.$route.query.max_ctc),
          notice_period: parseInt(this.$route.query.notice_period)
        }

      }
        this.candidateData = {
          firstName: res.data[0].first_name,
          lastName: res.data[0].last_name,
          email: res.data[0].email,
          contact: res.data[0].contact_no,
          //skillsSelected: { "title": res.data[0].skills },
          skillsSelected:  res.data[0].skills ,
          //source: {"title" : res.data[0].source },
          source:  res.data[0].source ,
          companyName: res.data[0].curr_company,
          jobTitle: res.data[0].curr_position,
          //selectedCity:  {"title" : res.data[0].curr_location },
          selectedCity:  res.data[0].curr_location ,
          preferredCities: prefCities,
          ctc: res.data[0].ctc,
          expectedCTC: res.data[0].exp_ctc,
          exp: res.data[0].exp,
          relevant_exp: res.data[0].relevant_exp,
          noticePeriod: res.data[0].notice_period,
          //qualification:  {"title" : res.data[0].qualification },
          qualification: res.data[0].qualification ,
          dob: res.data[0].dob === "1900-01-01" ? '' : res.data[0].dob,
          genderSelected:   res.data[0].gender ,
          //genderSelected:  {"title" : res.data[0].gender },
          remarks: res.data[0].remarks == null || res.data[0].remarks === 'null' ? '' : res.data[0].remarks,
          cv_path: res.data[0].cv_path || null,
        }
        this.originalCandidate = { ...this.candidateData }
        console.log('loading notice period: ', this.candidateData.noticePeriod, res.data[0].notice_period)
      }
      else {
        console.log("Candidate Data Fetch Failed")
      }

    })
    if (this.jobId) {
      CandidateService.getCandidateCurrentStatus(this.id, this.jobId).then( res => {
        if (res.status === 'OK') {
          this.prevStatus = res.data[0].candidateStatus
        }
      })
    }
  },
  computed: {
    isNotAnsweredCandidate() {
      return this.isNotAnsweredStatus(this.prevStatus)
        || this.isNotAnsweredStatus(this.$route.query && this.$route.query.candidateStatus)
    },
    isResumeRequired() {
      if (!this.jobId) return false
      return !this.existingResumeName
    },
    existingResumeName() {
      const path = this.candidateData && this.candidateData.cv_path
      if (!path) return ''
      const parts = String(path).split('/')
      return parts[parts.length - 1] || path
    },
  },
  methods: {
    isLoggedIn() {
      const expireIn = localStorage.getItem('expireIn')
      if (Math.floor(Date.now() / 1000 > expireIn)) {
          window.sessionStorage.setItem('lastPage', window.location.href.split('/#')[1])
          ////console.log("called logout")
          localStorage.clear();
          this.$router.push({ name: "auth-login" });
      }
    },
    openFile(event) {
      console.log(event.target.files)
      if(event.target.files) {
        this.file = event.target.files[0];
        console.log("file", this.file);
        console.log("cfile", this.candidateData.file)
      } else {
        this.invalidFile = true
        console.log(this.invalidFile)
      }
    },
    formSubmitted() {
      console.log('email send Selected', this.emailSendSelected)
      // Not Answered: do not ask or send the profile-shared email
      this.sendEmail = this.isNotAnsweredCandidate ? false : (this.emailSendSelected === 'YES')
      this.buttonClicked = true
      
      
      console.log(this.candidateData, 'buttonClicked: ' + this.buttonClicked, 'submit status: ', this.submitStatus)
      console.log('relevant exp: ', this.candidateData.relevant_exp)
      const validation = this.validationForm();
      console.log(validation)
      if(!validation) {
        this.buttonClicked = false
        this.submitStatus = 'Update'
        return;
      }
      if (this.confirmRemark === false && this.jobId && !this.blueCollar) {
        this.hygieneCheck()
      }
      if(this.blueCollar) {
        this.confirmRemark = true
      }
      if(!this.jobId) {
        this.confirmRemark = true
      }
      if(validation && this.confirmRemark) {
        this.submitStatus = 'Collect Data ...'
        console.log('source', this.candidateData.source)
        // let source = String(this.candidateData.source['title'])
        // if (source == undefined) {
        //   console.log("called")
        //   source =  this.candidateData.source[0].title
        // }
        // let qualification = String(this.candidateData.qualification['title'])
        // if (qualification == undefined) {
        //   console.log("called")
        //   qualification =  this.candidateData.qualification[0].title
        // }
        // // let noticePeriod = String(this.candidateData.noticePeriod['text'])
        // // if (noticePeriod == undefined) {
        // //   console.log("called")
        // //   noticePeriod =  this.candidateData.noticePeriod[0].text
        // // }
        // let gender = String(this.candidateData.genderSelected['title'])
        // if (gender == undefined) {
        //   console.log("called")
        //   gender =  this.candidateData.genderSelected[0].title
        // }
        const userData = JSON.parse(localStorage.getItem('userData'));
        const preCities = this.getPreferredCitiesString()
        const user = `[{"title" : "${userData.first_name} ${userData.last_name}", "emp_id": "${userData.emp_id}"}]`
        const userRole = userData.roles[0]
        const username = `${userData.first_name} ${userData.last_name}`
        // let city = String(this.candidateData.selectedCity['title'])
        // if (city == undefined) {
        //   console.log("called")
        //   city =  this.candidateData.selectedCity[0].title
        // }
        // let skills =  String(this.candidateData.skillsSelected['title'])
        // if (skills == undefined) {
        //   console.log("called")
        //   skills = this.candidateData.skillsSelected[0].title
        // }
        console.log("source", this.candidateData.source)
        console.log("skills", this.candidateData.skillsSelected)
        console.log("city", this.candidateData.selectedCity)
        console.log("gender", this.candidateData.genderSelected)
        console.log("precity",preCities, this.candidateData.preferredCities)
        //console.log("noticePeriod", noticePeriod)
        console.log("qualification",this.candidateData.qualification)
        const formData = new FormData()
        this.appendText(formData, 'first_name', this.keepOrOriginal('firstName'))
        this.appendText(formData, 'last_name', this.keepOrOriginal('lastName'))
        this.appendText(formData, 'email', this.candidateData.email || this.keepOrOriginal('email'))
        this.appendText(formData, 'curr_company', this.keepOrOriginal('companyName'))
        const contactDigits = this.keepOrOriginal('contact', (val) => {
          const digits = String(val).replace(/\D/g, '')
          return digits || ''
        })
        this.appendText(formData, 'contact_no', contactDigits)
        this.appendText(formData, 'curr_position', this.keepOrOriginal('jobTitle'))
        this.appendText(formData, 'curr_location', this.keepOrOriginal('selectedCity'))
        this.appendText(formData, 'pref_location', preCities)
        this.appendNumeric(formData, 'ctc', this.keepNumericOrOriginal('ctc'))
        this.appendNumeric(formData, 'exp_ctc', this.keepNumericOrOriginal('expectedCTC'))
        this.appendNumeric(formData, 'exp', this.keepNumericOrOriginal('exp'))
        this.appendNumeric(formData, 'relevant_exp', this.keepNumericOrOriginal('relevant_exp'))
        this.appendNumeric(formData, 'notice_period', this.keepNumericOrOriginal('noticePeriod', true))
        this.appendText(formData, 'skills', this.keepOrOriginal('skillsSelected'))
        this.appendText(formData, 'source', this.keepOrOriginal('source'))
        this.appendText(formData, 'qualification', this.keepOrOriginal('qualification'))
        const dob = this.candidateData.dob || (this.originalCandidate && this.originalCandidate.dob)
        if (this.hasValue(dob) && String(dob).slice(0, 10) !== '1900-01-01') {
          formData.append('dob', dob)
        }
        this.appendText(formData, 'gender', this.keepOrOriginal('genderSelected'))
        formData.append('updated_by', user)
        this.appendRemarks(formData, this.candidateData.remarks)
        if(this.jobId) {
          formData.append('jobData', JSON.stringify(this.jobData))
          formData.append('can_remarks', JSON.stringify(this.remarks))
        }
        console.log(this.candidateData.ctc, parseFloat(this.candidateData.ctc))
        if(this.candidateData.file) {
          formData.append('cvFile', this.candidateData.file)
        }  
        //formData.append('remarks', this.candidateData.remarks)
        
        //const toast = useToast()
        console.log(formData)
        CandidateService.updateCandidate(this.id, formData).then(res => {
          console.log(res)
          if (res && res.status === "OK") {
            this.submitStatus = 'Updating ...'
            
            if(this.jobId && this.interested === 'YES' && this.shouldShareProfileOnSubmit()) {
              this.candidateData = res.data
              console.log('send can data to mail',this.candidateData)
              this.updateCandidateStatus()
              
            } else {
              this.submitStatus = 'Update'
              this.buttonClicked = false
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Candidate Update Successful',
                  icon: 'EditIcon',
                  variant: 'success',
                  timeout: 5000,
                },
              })
            }
            
            this.$router.go(-1)
            return res.data          
          } else if (res && (res.status === 401 || res.status === 403)) {
            this.submitStatus = 'Update'
            this.buttonClicked = false
            window.sessionStorage.setItem('lastPage', window.location.href.split('/#')[1])
            localStorage.clear();
            this.$router.push({ name: "auth-login" });
          } else {
            this.handleUpdateFailure(res)
          }
        }).catch((err) => {
          console.log(err)
          this.handleUpdateFailure(err && err.response ? err.response : err)
        })
      } //else {
      //   this.buttonClicked = false
      //   this.submitStatus = 'Update'
      // }
    },
    hygieneCheck() {
      
      this.submitStatus = 'Hygiene Check ...'
      this.remarks = []
      // if (this.candidateData.exp && (this.candidateData.exp >= this.jobData.min_exp || this.candidateData.exp <= this.jobData.max_exp)) {
      //     remarks.push(`Candidate Experience(${this.candidateData.exp} Years) does not lie between Minimum (${this.jobData.min_exp}) & Maximum (${this.jobData.max_exp}) Experience Required for this job.`)
      // }
      // if (this.candidateData.relevant_exp && (this.candidateData.relevant_exp >= this.jobData.min_exp || this.candidateData.relevant_exp <= this.jobData.max_exp)) {
      //     remarks.push(`Candidate Relevant Experience (${this.candidateData.relevant_exp} Years) does not lie between Minimum (${this.jobData.min_exp}) & Maximum (${this.jobData.max_exp}) Experience Required for this job.`)
      // }
      // if(!this.blueCollar) {

        
        const noticePeriod = this.candidateData.noticePeriod
        console.log('in hygiene check: ', noticePeriod, this.candidateData.noticePeriod)
        const preCities = this.getPreferredCitiesString()
        if (this.candidateData.expectedCTC && (this.candidateData.expectedCTC > this.jobData.max_ctc)) {
            this.remarks.push(`Candidate Expected CTC (${this.candidateData.expectedCTC} Lacs) exceeds Maximum (${this.jobData.max_ctc}) CTC offered for this job.`)
        }
        if (noticePeriod && (noticePeriod > this.jobData.notice_period)) {
            this.remarks.push(`Candidate Notice Period (${noticePeriod} Days) is greater than Maximum Notice Period (${this.jobData.notice_period} Days) Required for this job.`)
        }
        console.log('cities: ',this.candidateData.preferredCities)
        console.log('job locations: ',)
        console.log('cities stringify: ',JSON.stringify(this.candidateData.preferredCities))
        console.log('cities json parse: ', preCities)
        //console.log('cities: ',preCities)
        if (preCities && this.jobData.locations && !this.jobData.locations.includes('Remote')) {
            let location_match = false
            let pref_location = [], locations = []
            // if (preCities.includes(',')) 
            // { 
            pref_location = preCities.split(",") 
            // }
            
            locations = this.jobData.locations.split(",") 
            
            //console.log(pref_location, locations)
            location_match = locations.some(item => pref_location.includes(item));
            console.log(pref_location, locations, location_match)
            if (!location_match) {
              this.remarks.push(`Candidate Preferred Locations (${preCities}) does not match the Locations (${this.jobData.locations}) available for this job.`)
            }
        }
        if(this.remarks.length > 0) {
          this.$refs['can-remarks-check'].show()
          // const btn = document.getElementsByClassName('close')
          // console.log('btn', btn)
          // btn[0].classList.add('hidden')
        } 
        else {
          this.confirmRemark = true
          //this.formSubmitted()
        }
      // }  
      //this.formSubmitted()
      //return this.confirmRemark
    },
    confirmRemarks() {
      this.confirmRemark = true
      this.formSubmitted()
    },
    validateEmail(email){
      if (!email) return false
      return String(email).match(
      /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
    },
    hasValue(val) {
      if (val === null || val === undefined) return false
      if (typeof val === 'number') return !Number.isNaN(val)
      if (typeof val === 'string') return val.trim() !== '' && val !== 'null'
      if (Array.isArray(val)) return val.length > 0
      return true
    },
    clearError(field) {
      if (this.error && this.error[field] !== undefined) {
        this.error[field] = ''
      }
    },
    isUsableEmail(email) {
      return !!this.validateEmail(email)
    },
    isUsableContact(contact) {
      if (!this.hasValue(contact)) return false
      const digits = String(contact).replace(/\D/g, '')
      return digits.length === 10
    },
    getPreferredCitiesString() {
      const prefs = this.candidateData.preferredCities
      if (!prefs) return ''
      if (typeof prefs === 'string') return prefs
      if (!Array.isArray(prefs)) return ''
      return prefs.map(item => (item && item.title) ? item.title : item).filter(Boolean).join(',')
    },
    keepOrOriginal(field, parser) {
      const current = this.candidateData[field]
      const original = this.originalCandidate ? this.originalCandidate[field] : ''
      const value = this.hasValue(current) ? current : original
      if (!this.hasValue(value)) return null
      return parser ? parser(value) : value
    },
    keepNumericOrOriginal(field, asInt) {
      const current = this.candidateData[field]
      const original = this.originalCandidate ? this.originalCandidate[field] : null
      const value = this.hasValue(current) || current === 0 ? current : original
      if (!this.hasValue(value) && value !== 0) return null
      const parsed = asInt ? parseInt(value, 10) : parseFloat(value)
      return Number.isNaN(parsed) ? null : parsed
    },
    appendText(formData, key, value) {
      if (value === null || value === undefined) return
      const str = String(value).trim()
      if (str === '' || str === 'null' || str === 'undefined') return
      formData.append(key, str)
    },
    appendNumeric(formData, key, value) {
      if (value === null || value === undefined || value === '') return
      const num = typeof value === 'number' ? value : parseFloat(value)
      if (Number.isNaN(num)) return
      formData.append(key, num)
    },
    appendRemarks(formData, value) {
      if (value === null || value === undefined) return
      const str = String(value)
      if (!str.trim() || str === 'null' || str === 'undefined') return
      formData.append('remarks', str)
    },
    extractUpdateErrorMessage(res) {
      const fallback = 'Candidate update failed. Please try again or check the fields.'
      if (!res) return fallback
      if (res.status === 413) return 'File Size is greater than 1 mb'
      if (typeof res === 'string') {
        if (res.includes('ERR_UPLOAD_FILE_CHANGED')) return 'Error in uploading file, please remove file and try again'
        return res || fallback
      }
      const data = res.data || {}
      const errors = data.error && data.error.errors
      const firstMsg = Array.isArray(errors) && errors[0] && errors[0].message
      if (firstMsg === 'email must be unique') {
        this.error.email = 'Duplicate! Email Already exists!'
        return 'Email already exists!'
      }
      if (firstMsg === 'contact_no must be unique') {
        this.error.contact = 'Duplicate! Contact No Already exists!'
        return 'Contact No already exists!'
      }
      if (firstMsg) return firstMsg
      if (data.message) return data.message
      if (data.error && typeof data.error === 'string') return data.error
      return fallback
    },
    handleUpdateFailure(res) {
      this.submitStatus = 'Update'
      this.buttonClicked = false
      const msg = this.extractUpdateErrorMessage(res)
      this.$toast({
        component: ToastificationContent,
        props: {
          title: 'Save failed. ' + msg,
          icon: 'AlertCircleIcon',
          variant: 'danger',
          timeout: 5000,
        },
      })
    },
    failValidation(focusRef) {
      this.buttonClicked = false
      this.submitStatus = 'Update'
      if (focusRef && this.$refs[focusRef] && this.$refs[focusRef].focus) {
        this.$nextTick(() => {
          this.$refs[focusRef].focus()
        })
      }
      return false
    },
    fieldText(val) {
      if (val === null || val === undefined) return ''
      if (typeof val === 'number') return Number.isNaN(val) ? '' : String(val)
      if (typeof val === 'string') return val.trim()
      if (Array.isArray(val)) return val.map(item => this.fieldText(item)).filter(Boolean).join(',')
      if (typeof val === 'object') {
        return String(val.title || val.value || val.text || val.name || '').trim()
      }
      return String(val).trim()
    },
    isFilled(val) {
      if (val === 0 || val === '0') return true
      const text = this.fieldText(val)
      return !!text && text !== 'null' && text !== 'undefined'
    },
    requireShareField(key, message, focusRef) {
      this.error[key] = message
      return this.failValidation(focusRef)
    },
    validationForm() {
      this.submitStatus = 'Validating ...'
      Object.keys(this.error).forEach(key => {
        this.error[key] = ''
      })

      const data = this.candidateData || {}

      if (!this.isFilled(data.firstName)) {
        return this.requireShareField('firstName', 'First Name is Mandatory', 'firstName')
      }
      if (!this.isFilled(data.lastName)) {
        return this.requireShareField('lastName', 'Last Name is Mandatory', 'lastName')
      }
      if (!this.isUsableEmail(data.email)) {
        return this.requireShareField('email', this.hasValue(data.email) ? 'Email is Invalid' : 'Email is Mandatory', 'email')
      }
      if (!this.isUsableContact(data.contact)) {
        const contactMsg = this.hasValue(data.contact) ? 'Contact No should be 10 digits' : 'Contact No is Mandatory'
        return this.requireShareField('contact', contactMsg, 'contact')
      }
      if (!this.isFilled(data.jobTitle)) {
        return this.requireShareField('jobTitle', 'Job Title is Mandatory, use NA for freshers', 'job_title')
      }
      if (!this.isFilled(data.companyName)) {
        return this.requireShareField('companyName', 'Company Name is Mandatory, use NA for freshers', 'companyName')
      }
      if (!this.isFilled(data.ctc) && data.ctc !== 0) {
        return this.requireShareField('ctc', 'CTC is Mandatory, use 0 for freshers', 'ctc')
      }
      if (!this.isFilled(data.expectedCTC) && data.expectedCTC !== 0) {
        return this.requireShareField('expectedCTC', 'Expected CTC is Mandatory', 'expectedCTC')
      }
      if (!this.isFilled(data.exp) && data.exp !== 0) {
        return this.requireShareField('exp', 'Experience is Mandatory(if fresher mention 0)', 'exp')
      }
      if (!this.isFilled(data.relevant_exp) && data.relevant_exp !== 0) {
        return this.requireShareField('relevant_exp', 'Relevant Experience is Mandatory(if fresher mention 0)', 'relevant_exp')
      }
      if (!this.isFilled(data.noticePeriod) && data.noticePeriod !== 0) {
        return this.requireShareField('noticePeriod', 'Notice Period is Mandatory, use Immediate for freshers', 'noticePeriod')
      }
      if (!this.isFilled(data.selectedCity) || !/[a-z]/i.test(this.fieldText(data.selectedCity))) {
        return this.requireShareField('selectedCity', 'City is Mandatory', 'city')
      }
      if (!this.isFilled(data.preferredCities) || !/[a-z]/i.test(this.fieldText(data.preferredCities))) {
        return this.requireShareField('preferredCities', 'Preferred Location is Mandatory', 'preCity')
      }
      if (!this.isFilled(data.skillsSelected)) {
        return this.requireShareField('skillsSelected', 'Skills is Mandatory', 'skills')
      }
      if (!this.isFilled(data.qualification) || !/[a-z]/i.test(this.fieldText(data.qualification))) {
        return this.requireShareField('qualification', 'Qualification is Mandatory', 'qualification')
      }
      if (!this.isFilled(data.source) || !/[a-z]/i.test(this.fieldText(data.source))) {
        return this.requireShareField('source', 'Source is Mandatory', 'source')
      }
      if (!this.isFilled(data.genderSelected) || !/[a-z]/i.test(this.fieldText(data.genderSelected))) {
        return this.requireShareField('gender', 'Gender is Mandatory', 'gender')
      }

      if (this.invalidFile || (this.file && this.file.size > 1690000)) {
        this.error.file = this.invalidFile ? 'Not a Vaild File' : 'File should not be greater than 1.5MB'
        return this.failValidation('file')
      }
      if (this.isResumeRequired && !data.file && !this.file) {
        return this.requireShareField('file', 'Resume/CV is Mandatory', 'file')
      }

      return true
    },
    enableButton() {
      this.buttonClicked = false
      this.submitStatus = 'Update'
    },
    isNotAnsweredStatus(status) {
      if (status == null || status === '') return false
      const normalized = String(status).trim().toLowerCase().replace(/[\s_-]+/g, '')
      return normalized === 'notanswered'
    },
    shouldShareProfileOnSubmit() {
      const preProfileSharedStatuses = [
        'UploadedBySourcer', 'UploadedByRecruiter', 'AssignedByMassMail',
        'Not Interested', 'Not Relevant', 'Not Answered', 'Not Reachable',
        'Wrong Number', 'Call Back', 'Duplicate', 'AssignedByATSSourcer',
        'Initiated', 'AssignedByJobPost', 'AssignedByATSMassMailer',
      ]
      return !this.prevStatus || preProfileSharedStatuses.includes(this.prevStatus)
    },
    updateCandidateStatus() {
      console.log('in mail candidate data', this.candidateData, this.candidateData.email);
      // if(this.blueCollar) {
      //   this.statusCSelected = 'Confirmed'  
      // } else {
        this.statusCSelected = 'ProfileShared'
      // }
      
      const userData = JSON.parse(localStorage.getItem("userData"));
      const user = `[{"title" : "${userData.first_name} ${userData.last_name}", "emp_id": "${userData.emp_id}"}]`;
      const username = `${userData.first_name} ${userData.last_name}`
      const useremail = userData.email
      const role = userData.roles[0]
      
      console.log('allUsers', this.allUsers, userData.mgr_id, userData.emp_id)//const allUsers = JSON.parse(localStorage.getItem("allusers"));
      const mgr = this.allUsers.filter(item => item.emp_id === userData.mgr_id)

      const p_mgr_id = mgr[0].manager
      //this.statusCSelected
      let status = {
        candidateStatus: this.statusCSelected,
        updatedBy: user,
        recruiter: userData.emp_id,
        mgr_id: userData.mgr_id,
        p_mgr_id: p_mgr_id,
        // "Manager Name": role === 'TALENT-ADVISOR-SOURCER' ? mgr[0].title.toUpperCase() : username.toUpperCase(),
        "Manager Name": this.$can('read','talent_acquisition') ? mgr[0].title.toUpperCase() : username.toUpperCase(),
        "Employee Name": username.toUpperCase(),
        reason: '',
        comment: '',
        source: this.fieldText(this.candidateData.source),
        emp_type: this.positionType,
        send_email: this.sendEmail
      };
      if (this.client === 'KPMG RPO' && (this.jobId === 3194 || this.jobId === 3425 || this.jobId === 3385)) {

        if(!this.extraDetails.level) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Level must be selected from dropdown',
              icon: 'EditIcon',
              variant: 'danger',
              timeout: 7000,
            },
          })
          return
        }

        if(this.extraDetails.level.length <= 2) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Level must be at least 3 characters long',
              icon: 'EditIcon',
              variant: 'danger',
              timeout: 7000,
            },
          })
          return
        }

        if(!this.extraDetails.reqId || this.extraDetails.reqId.length < 6) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Request ID must be at least 6 characters long',
              icon: 'EditIcon',
              variant: 'danger',
              timeout: 7000,
            },
          })
          return
        }

        if(!this.extraDetails.candidateId || this.extraDetails.candidateId.length < 6) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Candidate ID must be at least 6 characters long',
              icon: 'EditIcon',
              variant: 'danger',
              timeout: 7000,
            },
          })
          return
        }

        if(!this.extraDetails.jurisdictions) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Jurisdictions is mandatory',
              icon: 'EditIcon',
              variant: 'danger',
              timeout: 7000,
            },
          })
          return
        }

        const communicationScore = parseFloat(this.extraDetails.communicationScore)
        if(isNaN(communicationScore) || communicationScore < 0 || communicationScore > 5) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Communication Score must be between 0 and 5',
              icon: 'EditIcon',
              variant: 'danger',
              timeout: 7000,
            },
          })
          return
        }

        status.extra_details = {
          business: this.extraDetails.business,
          pocs: this.extraDetails.pocs,
          reqId: this.extraDetails.reqId,
          candidateId: this.extraDetails.candidateId,
          level: this.extraDetails.level,
          "Which all juridictions have you done KYC for?": this.extraDetails.jurisdictions,
          communicationScore: this.extraDetails.communicationScore
        };
      }
      const timelineData = {
              title: `Candidate - ${this.id} Status Changes to ${this.statusCSelected}`,
              description: `CS-Changed`, /// CS-Changed means candidate status changed
              type: "success",
              createdBy: username,
              jobId: this.jobId,
              action: 'candidate-edit',
              candidate_id: this.id,
              candidateStatus: this.statusCSelected
            }
      status.jt = timelineData  
      console.log('edit timeline data', status.jt);  
      CandidateService.updateCandidateStatus(this.id, this.jobId, status).then(
        (res) => {
          console.log(res.data);
          if (res.status === "OK") {
            const updateCandidateResponse = res.data
            this.submitStatus = 'Status Updated ...'
            console.log('in update status ok')
            // const timelineData = {
            //   title: `Candidate - ${this.id} Status Changes to ${this.statusCSelected}`,
            //   description: `CS-Changed`, /// CS-Changed means candidate status changed
            //   type: "success",
            //   createdBy: username,
            //   jobId: this.jobId,
            //   candidate_id: this.id,
            //   candidateStatus: this.statusCSelected
            // }
            
            
            //jobTimelineService.create(timelineData).then(res => {
            //  console.log("edit timeline", res)
                if((this.statusCSelected === "ProfileShared" || this.statusCSelected === "Confirmed") && this.jobId) {
                  this.submitStatus = 'Timeline Added ...'
                  //JobService.getJob(this.jobId).then( res => {
                    //const jobData = res.data;
                    //console.log("in if mail", jobData)
                    
                    
                    if(this.candidateData) {
                      //Added Exclusion for Mail sending on client LTI RPO & dummy
                      console.log('client and email send check: ', this.client, this.sendEmail)
                      
                      // if(this.sendEmail && this.client !== 'LTI RPO' && this.client !== 'Dummy' && this.client !== 'Sonata Technologies' && this.client !== 'Wipro RPO' && this.client != undefined && this.client !== 'AXA XL-RR' && this.client !== 'Vector3 Digital Tech' && this.client !== 'Larsen & Toubro' && this.client !== 'Zamil Steel') {
                      if(this.sendEmail && this.client !== 'LTI RPO' && this.client !== 'Dummy' && this.client !== 'Sonata Technologies' && this.client !== 'Wipro RPO' && this.client != undefined && this.client !== 'AXA XL-RR' && this.client !== 'Vector3 Digital Tech') {
                        this.submitStatus = 'Collect mail data ...'
                        console.log('client and email send check: ', this.client, this.sendEmail)
                        const mailData = {
                          can_email: this.candidateData.email,
                          can_fname: `${this.candidateData.first_name} ${this.candidateData.last_name}`,
                          can_contact: this.candidateData.contact_no,
                          can_position: this.candidateData.curr_position,
                          can_company: this.candidateData.curr_company,
                          can_qualification: this.candidateData.qualification,
                          can_gender: this.candidateData.gender,
                          can_dob: this.candidateData.dob == '1900-01-01' ? '' : this.candidateData.dob,
                          can_exp: this.candidateData.exp,
                          can_ctc: this.candidateData.ctc,
                          can_exp_ctc: this.client !== 'KPMG RPO' ? this.candidateData.exp_ctc : 'As discussed over the phone 20%-25% on your current fixed CTC.',
                          can_skills: this.candidateData.skills,
                          can_city: this.candidateData.curr_location,
                          can_pref_city: this.candidateData.pref_location,
                          can_notice_period: this.candidateData.notice_period,
                          cv_file: this.candidateData.cv_path,                                 
                          am_email: `${useremail}`,
                          position_name: this.position_name,
                          client: this.client.replace("RPO", ""),
                          location: this.locations,
                          rec_email: useremail,
                          rec_name: username,
                          jd_file: this.attachments ? this.attachments : ''//.replace("/","%2F")                     
                        }
                        console.log("in if mail-1", mailData)
                        let mail = ''
                        this.submitStatus = 'Sending mail ...'
                        if (this.attachments) {
                          mail = emailTemplates.candidateProfileShared(mailData)
                        } else {
                          mail = emailTemplates.candidateProfileSharedNoJD(mailData)
                        }
                        const mail_body = {
                            ...mail, // Use Sequelize's .dataValues to get a plain object of the model
                            timeline_id: updateCandidateResponse.timeline // Append the newly created timeline object
                        };
                        console.log("in if mail-2", mail)
                        if (mail && process.env.NODE_ENV === "production") {
                          mailService.mail(mail_body).then(res => {
                            console.log("in if mail-2", res)
                            this.submitStatus = 'Update'
                            this.buttonClicked = false
                          })
                        }
                      }
                    }
                  //})
                
                }

            //})
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Candidate Update Successful',
                icon: 'EditIcon',
                variant: 'success',
                timeout: 5000,
              },
            })
            //this.getAllJobs();
          } else {
            this.submitStatus = 'Failed'
            this.buttonClicked = false
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Candidate Update Failed",
                icon: "EditIcon",
                variant: "danger",
                timeout: 3000,
              },
            });
          }
        }
      );
    },
    calculateAge(dobString) {
    // Parse the DOB string (e.g. "1985-07-15") into year, month, and day
      const [year, month, day] = dobString.split("-").map(Number);
      
      // Create a Date object for the DOB
      // Note: JavaScript months are zero-based, so subtract 1 from `month`.
      const dob = new Date(year, month - 1, day);
      
      // Get today's date
      const today = new Date();
      
      // Calculate the rough age
      let age = today.getFullYear() - dob.getFullYear();
      
      // Adjust if the birthday hasn't happened yet this year
      const monthDiff = today.getMonth() - dob.getMonth();
      const dayDiff = today.getDate() - dob.getDate();
      if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
        age--;
      }
      console.log('in calculate age: ', age)
      return age;
    }

  },
  mounted() {
    this.$refs.job_title.focus()
    //getATSDropdownList
    adminConfigService.getATSDropdownList().then(res => {
      if(res.status === 200) {
        this.sources = res.data.data.sourceList
        this.qualifications = res.data.data.qualificationList
      }
    })
    if(this.client === 'KPMG RPO') {
      adminConfigService.getClientDropdownList(this.client).then(res => {
        if(res.status === 200) {
          console.log('in kpmg rpo dropdown list', res.data.data)
          // this.businessList = res.data.data.businessList || 'Other'
          // this.businessList = res.data.data.businessList || 'Other'
          // this.pocList = res.data.data.pocList || 'Other'
          this.levelList = res.data.data.levelList || 'Other'
        }
      })
    }
    // adminConfigService.getATSDropdownList().then(res => {
    //   if(res.status === 200) {
    //     this.sources = res.data.data
    //   }
    // })
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import '@core/scss/vue/libs/vue-flatpicker.scss';

#add-new-candidate-sidebar {
  .vs__dropdown-menu {
    max-height: 200px !important;
  }
}
.b-sidebar.sidebar-lg {
  width: 45rem;
  padding-left: 15px;
  padding-right: 15px;
}
.hidden{
  display: none;
}
</style>
